import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { PocketbaseService } from '../../services/pocketbase.service';
import { SocialLoginComponent } from "../social-login/social-login.component";
import { ClientResponseError } from 'pocketbase';
import { checkPasswords } from '../auth';

const DEFAULT_REGISTRATION_FAILURE_MESSAGE = 'Bei der Registrierung mit dieser Email ist ein Fehler aufgetreten. Bitte versuche es später oder mit einer anderen Email erneut.';

@Component({
    selector: 'app-register',
    imports: [CommonModule, SocialLoginComponent, RouterLink, ReactiveFormsModule],
    templateUrl: './register.component.html',
    styleUrl: './register.component.scss'
})
export class RegisterComponent {
  registrationForm: FormGroup;

  verificationSent = false;
  registrationFailed = false;
  registrationFailureMessage = DEFAULT_REGISTRATION_FAILURE_MESSAGE;

  readonly returnUrl: string;

  constructor(
    private readonly pocketbaseService: PocketbaseService,
    private readonly fb: FormBuilder,
    private readonly route: ActivatedRoute

  ) {
    this.returnUrl = this.route.snapshot.queryParamMap.get('returnUrl') || '/';

    if (pocketbaseService.loggedIn() && pocketbaseService.pb.authStore.model != null) {
      // could display this to the user if we wanted to
      console.warn(`already logged in as ${pocketbaseService.pb.authStore.model['email']}`);
    }

    this.registrationForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      passwordConfirm: ['', Validators.required]
    },
      { validators: checkPasswords }
    );
  }

  async onSubmit() {
    if(this.registrationForm.valid){
      this.verificationSent = false;
      this.registrationFailed = false;
      this.registrationFailureMessage = DEFAULT_REGISTRATION_FAILURE_MESSAGE;

      const email = this.registrationForm.get('email')?.value;
      const password = this.registrationForm.get('password')?.value;
      const passwordConfirm = this.registrationForm.get('passwordConfirm')?.value;
  
      this.pocketbaseService.pb.collection('users').create({ email, password, passwordConfirm }).then(() => {
        // user created, needs to verify email
        this.pocketbaseService.pb.collection('users').requestVerification(email).then(() => {
          this.verificationSent = true;
        })
      }).catch((e: ClientResponseError) => {
        this.registrationFailed = true;
        if (e.response['data']['email']?.code == 'validation_invalid_email') {
          // invalid email might mean that user is alreadey registered. do they maybe need to verify their email?
          this.pocketbaseService.pb.collection('users').requestVerification(email).then(() => {
            this.registrationFailureMessage = 'Dieser Account existiert bereits, aber deine Email ist noch nicht bestätigt. Wir haben dir den Link zur Verifizierung soeben erneut zugesendet.'
          })
        }
        // otherwise, the default error message is fine
      });
    }
  }
}
